<div class="wrapper rounded-large border">
  <div class="card">
    <fcom-image
      *ngIf="image"
      class="picture"
      [ratio]="imageRatio$ | async"
      [alt]="image.alt"
      [imageData]="image"
      [style.minHeight.px]="notifications.clientHeight"
    ></fcom-image>
    <div class="notification" [ngClass]="{ 'mr-small has-image': image }" #notifications>
      <ng-content select="fcom-notification, [notifications]"></ng-content>
    </div>

    <div class="details pr-small-t white-bg pr-small-b" [ngClass]="{ 'border-top has-image': image }">
      <div class="destinations font-heading-3 nordic-blue-900-text mr-small-x">
        <span [title]="destinations ? destinations.join(' - ') : ''">
          <span *ngFor="let pair of destinationPairs; index as i; last as last" class="destination ms-xsmall-r">
            <span>{{ pair[0] }}</span>
            <fcom-icon
              class="icon-medium"
              [name]="journeyType === JourneyType.RETURN ? 'return-trip' : 'aircraft-horizontal'"
            ></fcom-icon>
            <span>{{ pair[1] }}</span>
            <span *ngIf="!last">, </span>
          </span>
        </span>
      </div>
      <div class="timeline nordic-blue-900-text font-body-2 pr-small-x">
        {{ departureDate }}{{ arrivalDate ? ' - ' + arrivalDate : '' }}
      </div>
      <div class="summary-container flex ms-xsmall-t pr-small-x">
        <div class="summary nordic-blue-900-text font-body-2 flex-1">
          <span class="passengers pr-xsmall-r" *ngIf="passengerAmount">
            <fcom-icon
              [attr.aria-label]="'tripCard.passengerAmount' | finLocalization"
              class="icon-small ms-xxsmall-r"
              name="adult-infant"
            ></fcom-icon>
            <span>{{ passengerAmount }}</span>
          </span>
          <span class="booking-ref pr-xsmall-r" *ngIf="bookingRef" data-hj-suppress>
            <fcom-icon
              [attr.aria-label]="'tripCard.bookingReference' | finLocalization"
              class="icon-small ms-xxsmall-r"
              name="book-flight"
            ></fcom-icon>
            <span>{{ bookingRef }}</span>
          </span>
          <span class="flight-type" *ngIf="journeyType">
            <fcom-icon
              [attr.aria-label]="'tripCard.journeyType' | finLocalization"
              class="icon-small ms-xxsmall-r"
              [name]="journeyIcon"
            >
            </fcom-icon>
            <span>{{ 'tripCard.tripType.' + journeyType | finLocalization }}</span>
          </span>
        </div>
        <div class="flex--shrink0 expand-details">
          <button
            [attr.aria-label]="(expanded ? 'tripCard.ariaHide' : 'tripCard.ariaShow') | finLocalization"
            [attr.aria-controls]="expandContainerId"
            [attr.aria-expanded]="expanded"
            [id]="expandButtonId"
            (click)="toggleExpand($event)"
            class="font-body-1 mr-small-l nordic-blue-900-text underline medium-type"
          >
            <span>{{ (expanded ? 'tripCard.hideFlights' : 'tripCard.showFlights') | finLocalization }}</span>
            <fcom-icon [class.chevron-open]="expanded" class="icon-medium ms-xxsmall-l chevron" name="chevron-down">
            </fcom-icon>
          </button>
        </div>
      </div>
    </div>
  </div>
  <fcom-expand [open]="expanded" [ariaId]="expandContainerId" [ariaLabelledBy]="expandButtonId" class="block">
    <div class="expanded-content">
      <ng-content></ng-content>
    </div>
  </fcom-expand>
</div>
